import { hashString } from './hashString';
export const createUniqueClassName = (block, elementName) => {
    const hash = hashString('universal-nav' + block + elementName);
    return `${block}__${elementName}-${hash}`;
};
//# sourceMappingURL=createUniqueClassName.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
